"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addInfoEvent = exports.instantiateAblePlayer = void 0;
var instantiateAblePlayer = function (video) {
    var _a;
    var ablePlayerInstance = new AblePlayer(video);
    AblePlayerInstances.push(ablePlayerInstance);
    var animationId = video.dataset.animationId;
    var videoTitle = (_a = video.dataset.animationTitle) !== null && _a !== void 0 ? _a : "Skills Animation";
    if (animationId && animationId.length > 0) {
        (0, exports.addInfoEvent)(ablePlayerInstance.media, animationId, videoTitle);
    }
    return function () {
        AblePlayerInstances.splice(AblePlayerInstances.indexOf(ablePlayerInstance));
    };
};
exports.instantiateAblePlayer = instantiateAblePlayer;
var addInfoEvent = function (video, animationId, animationTitle) {
    var _a, _b;
    video.addEventListener("contextmenu", function (event) {
        event.preventDefault();
    });
    (_a = video.parentElement) === null || _a === void 0 ? void 0 : _a.addEventListener("contextmenu", function (event) {
        event.preventDefault();
    });
    (_b = video.parentElement) === null || _b === void 0 ? void 0 : _b.addEventListener("mouseup", function (event) {
        var configId = video.id + "-info-config";
        var configMenuItem = document.createElement("li");
        configMenuItem.ariaRoleDescription = "menuitem";
        configMenuItem.innerText = "Info";
        configMenuItem.classList.add("able-focus");
        configMenuItem.id = configId;
        configMenuItem.addEventListener("click", function (event) {
            showAnimationIdInfo(video, animationId, animationTitle !== null && animationTitle !== void 0 ? animationTitle : 'Skills Animation');
        });
        var prefsMenu = document.querySelector("#" + video.id + "-prefs-menu");
        configMenuItem.addEventListener("keydown", function (event) {
            if (event.key == "Enter") {
                showAnimationIdInfo(video, animationId, animationTitle !== null && animationTitle !== void 0 ? animationTitle : 'Skills Animation');
                if (prefsMenu) {
                    prefsMenu.style.display = "none";
                }
            }
        });
        if (document.querySelector("#" + configId) == null) {
            prefsMenu === null || prefsMenu === void 0 ? void 0 : prefsMenu.appendChild(configMenuItem);
        }
    });
};
exports.addInfoEvent = addInfoEvent;
var showAnimationIdInfo = function (element, animationId, animationTitle) {
    var elementId = "info_" + animationId;
    var shouldAddMessageBox = document.querySelector("#" + elementId) == null;
    var parser = new DOMParser();
    if (shouldAddMessageBox) {
        var containerElement_1 = document.createElement("div");
        var messageBoxElement = document.createElement("div");
        var titleSpanElement = document.createElement("span");
        var idSpanElement = document.createElement("span");
        var closeButtonElement = document.createElement("span");
        var xElementHtml = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70 120\" height=\"24\" width=\"14\">\
                                <path d=\"M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88\" />\
                                </svg>";
        var xElement = parser.parseFromString(xElementHtml, "text/html").body.childNodes[0];
        titleSpanElement.innerText = animationTitle;
        idSpanElement.innerText = "ID: " + animationId;
        containerElement_1.id = elementId;
        closeButtonElement.ariaLabel = "Close";
        closeButtonElement.tabIndex = 0;
        messageBoxElement.classList.add("info-message-box");
        containerElement_1.classList.add("info-container");
        closeButtonElement.classList.add("info-close-button");
        closeButtonElement.appendChild(xElement);
        messageBoxElement.appendChild(closeButtonElement);
        messageBoxElement.appendChild(titleSpanElement);
        messageBoxElement.appendChild(idSpanElement);
        containerElement_1.appendChild(messageBoxElement);
        element.insertAdjacentElement("beforebegin", containerElement_1);
        var closeInfoBox_1 = function (box) { var _a; return (_a = box.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(box); };
        closeButtonElement.addEventListener("click", function () { return closeInfoBox_1(containerElement_1); });
        closeButtonElement.addEventListener("keydown", function (event) {
            if (event.key == "Enter") {
                closeInfoBox_1(containerElement_1);
            }
        });
    }
};
